import { render } from "./SoldGiftVoucherDataModal.vue?vue&type=template&id=46e27da6"
import script from "./SoldGiftVoucherDataModal.vue?vue&type=script&lang=js"
export * from "./SoldGiftVoucherDataModal.vue?vue&type=script&lang=js"

import "./SoldGiftVoucherDataModal.vue?vue&type=style&index=0&id=46e27da6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__